export const DataScopeTypeList = [
  {
    label: '全部',
    value: '0'
  },
  {
    label: '自定义',
    value: '1'
  },
  {
    label: '本级',
    value: '3'
  },
  {
    label: '本级及子级',
    value: '2'
  }
]

export const statusTypeList = [
  {
    label: '禁用',
    value: '0'
  },
  {
    label: '正常',
    value: '1'
  }
]
